import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useForm } from "react-hook-form";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import clsx from "clsx";
import { useBadInventoryActionsAPI } from "@/app/hooks/api_hooks/Inventory/BadInventory/useBadInventoryActionsAPI";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useEffect } from "react";

export interface IInvalidImageModalProps {
  reason: string;
}

const InvalidImageContent = ({ formHook }) => {
  return (
    <div>
      <div className="justify-start items-center gap-16 inline-flex mt-5 mb-10">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px]">
          <span className="font-normal text-black text-xs">Provide Reason</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <div className="w-72">
          <textarea
            rows={4}
            style={{
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
            className={clsx(
              `rounded-md w-full h-full border text-xs`,
              formHook?.formState?.errors?.reason ? "outline-red-300 border-red-600" : "border-gray-300",
            )}
            placeholder="Please enter reason"
            {...formHook.register(`reason`, {
              required: true,
              minLength: 1,
            })}
          />
          {formHook?.formState?.errors?.reason && (
            <p className="text-red-500 absolute text-[10px] -mt-1">Reason is required</p>
          )}
        </div>
      </div>
    </div>
  );
};

const InvalidImageModal = () => {
  const { setInvisible } = useModalActions("INVALID_IMAGE");
  const modalState = useModalState("INVALID_IMAGE");
  const { execute: actionsOnBad } = useBadInventoryActionsAPI(modalState?.refreshData);

  const formHook = useForm<IInvalidImageModalProps>({
    mode: "onChange",
  });

  useEffect(() => {
    if (modalState?.visible) {
      formHook.reset({ reason: "" });
    }
  }, [modalState?.visible]);

  const handleSubmit = async (data: IInvalidImageModalProps) => {
    if (!modalState?.bad_inventory_id) {
      console.error("Missing bad_inventory_id");
      return;
    }
    await actionsOnBad({
      bad_inventory_id: modalState.bad_inventory_id,
      action: "invalid_image",
      reason_of_invalid_image: data.reason,
    });
    formHook.setValue("reason", null);
    setInvisible();
  };

  return (
    <ModalPrompt
      modalId="INVALID_IMAGE"
      showIcon={false}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Save",
        secondaryButtonText: "Cancel",
        primaryButtonClassname: `px-6 py-[9px] rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex cursor-pointer bg-sky-900 hover`,
        primaryCallback: formHook.handleSubmit(handleSubmit),
        secondaryCallback: () => {
          formHook.setValue("reason", null);
          setInvisible();
        },
        onCrossClick: () => {
          formHook.reset();
          setInvisible();
        },
      }}
      title="Invalid Image"
      content={<InvalidImageContent formHook={formHook} />}
    />
  );
};

export default InvalidImageModal;
